import { render, staticRenderFns } from "./practiceClass.vue?vue&type=template&id=00c90173&scoped=true&"
import script from "./practiceClass.vue?vue&type=script&lang=js&"
export * from "./practiceClass.vue?vue&type=script&lang=js&"
import style0 from "./practiceClass.vue?vue&type=style&index=0&id=00c90173&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c90173",
  null
  
)

export default component.exports